/**
 *
 * @author: Matthew Rawson @ 04/09/2018 11:19
 * @description:
 * @notes:
 */
import React, {Fragment} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import theme from "@irati/ui/src/global/theme"
import {TextButton} from "@irati/ui/src/Button"
import {WorkSansBold} from "@irati/ui/src/global/fonts"
import {Label} from "@irati/ui/src/Typography"
import {regularStyles} from "@irati/ui/src/Typography/Label/styles"

const Button = styled(TextButton)`
  ${regularStyles}
  padding: 11px 16px;
  display: inline-block;
  color: ${theme.colors.greys.mediumDark};
  user-select: none;

  ${({disabled}) =>
    disabled &&
    `
    color: ${theme.colors.greys.mediumLight};
    cursor: not-allowed;
  `}

  ${({active}) =>
    active &&
    `
    cursor: not-allowed;
    box-shadow: 0 0 0 1px ${theme.colors.greys.mediumDark};
    border-radius: 3px;
    ${WorkSansBold}
  `}

  &:hover {
    ${({active, disabled}) => !(active || disabled) && `background-color: ${theme.colors.greys.light};`}
    ${({disabled}) => !disabled && `box-shadow: 0 0 0 1px ${theme.colors.greys.mediumDark};`}
    border-radius: 3px;
  }
`

const StyledLabel = styled(Label)`
  user-select: none;
`

const PaginationButton = ({children, isPlaceholder, ...props}) => {
  const idNamespace = id("PaginationButton", props)

  return (
    <Fragment>
      {!isPlaceholder && (
        <Button id={id("button", idNamespace)} {...props}>
          {children}
        </Button>
      )}
      {isPlaceholder && <StyledLabel id={id("label", idNamespace)}>{children}</StyledLabel>}
    </Fragment>
  )
}

PaginationButton.propTypes = {
  isPlaceholder: PropTypes.bool,
  children: PropTypes.any
}
PaginationButton.defaultProps = {
  isPlaceholder: false,
  children: null
}

export default PaginationButton
